import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { localeStrings as strings } from 'applicationConfig';
import ReportingGrid from './ReportingGrid';
import paths from '../../common/constants/paths';
import PageSubcaption from '../layouts/MainLayout/PageSubcaption';

import './reporting.scss';

@inject('executionReportingStore')
@observer
class Reporting extends Component {

  get publishers() {
    return this.props.executionReportingStore.publishers;
  }

  get items_IF() {
    return this.publishers.map(publiser => (publiser.type === 'IF' ? {
      id: publiser.id,
      name: publiser.name,
      options: publiser.reports.map(report => ({
        value: report.id,
        label: report.name
      }))
    } : null)).filter(item => !!item);
  }

  get items_TV() {
    return this.publishers.map(publiser => (publiser.type === 'TV' ? {
      id: publiser.id,
      name: publiser.name,
      options: publiser.reports.map(report => ({
        value: report.id,
        label: report.name
      }))
    } : null)).filter(item => !!item);
  }

  handleClick = (data) => {
    // data: { id: string, selected: string }
    const publisher = this.publishers.find(publisher => publisher.id === data.id);
    const report = publisher.reports.find(report => report.id === data.selected);
    this.props.history.push({
      pathname: paths.reportingDownload,
      state: {
        publisherId: publisher.id,
        publisherType: publisher.type,
        name: publisher.name,
        date: report.date,
        formattedDate: report.name
      }
    });
  };

  componentDidMount() {
    this.props.executionReportingStore.loadPublishers();
  }

  render() {
    return (
      <div className="execution-reporting-page">
        <div className="execution-reporting-body">
          <p>{strings.executionReporting.publishingInfo}</p>
          <PageSubcaption caption={strings.executionReporting.investmentCaption} />
          <ReportingGrid data={this.items_IF} onClick={this.handleClick} />
          <PageSubcaption caption={strings.executionReporting.venueCaption} />
          <ReportingGrid data={this.items_TV} onClick={this.handleClick} />
        </div>
      </div>
    );
  }
}
export default Reporting;



// WEBPACK FOOTER //
// ./src/containers/Reporting/Reporting.jsx